// extracted by mini-css-extract-plugin
module.exports = {"body-container":"components-Body-Body__body-container--3kT6M","body":"components-Body-Body__body--20HKG"};